import React from "react";
import _ from "lodash";
import { BottomNavigation, BottomNavigationAction, Box } from "@mui/material";
import { ChoiceRail } from "@dishopsaas/design-system";
import {
  choiceRailOptionsByType,
  STATUS,
} from "../../../constants/addressInput";
import { OrderTypeSwitchProps } from "../../../1_types/AddressInputTypes";
import getStyles from "../AddressInput.styles";
export default function OrderTypeSwitch({
  orderTypes,
  isMobile,
  orderTypeChoiceIndex,
  handleOrderTypeSelection,
}: OrderTypeSwitchProps) {
  const styles = getStyles()
  return (
    <Box>
      <BottomNavigation
        showLabels
        value={orderTypeChoiceIndex}
        onChange={async (event, selectedOrderTypeIndex) =>
          await handleOrderTypeSelection(selectedOrderTypeIndex)
        }
        style={styles.bottomNavigationContainer}
      >
        {orderTypes &&
          _.map(orderTypes, (c, index) => {
            const options = choiceRailOptionsByType(isMobile);
            const railOption = options[c] ?? options.default;

            return (
              <BottomNavigationAction
                key={index}
                value={index}
                disableRipple
                sx={styles.bottomNavigation}
                icon={
                  <ChoiceRail
                    options={[
                      {
                        id: railOption.id,
                        status: STATUS.OPEN,
                      },
                    ]}
                    labelOpen={railOption.labelOpen}
                    imageName={railOption.imageName}
                    value={
                      orderTypeChoiceIndex === index ? [railOption.id] : []
                    }
                    selectionMode="single"
                    width="100%"
                  />
                }
              />
            );
          })}
      </BottomNavigation>
    </Box>
  );
}
